import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
import { CreateHeader, Footer } from 'shared/ui/dialog-header';
import { translate } from 'i18n/jhipster-language';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { createEntity as createReplacementRequest, clearMutationFlags, } from 'shared/lib/reducers/card-replacement-request.reducer';
import { CARD_REPLACEMENT_DEFAULT_SOURCE_CHANNEL, CARD_REPLACEMENT_REASON_OPTIONS, } from 'shared/lib/card-replacement-form.constants';
import { buildAuthUserDisplayName } from 'shared/lib/auth-user-display';
const CardReplacementRequestCreateDialog = ({ card, closeDialog, onCreated, updating, updateSuccess, account, submitRequest, clearFlags, }) => {
    const cardId = card.id;
    const [reason, setReason] = useState(null);
    const [touchedSubmit, setTouchedSubmit] = useState(false);
    useEffect(() => {
        clearFlags();
    }, [clearFlags]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        onCreated?.();
        clearFlags();
        closeDialog?.();
    }, [updateSuccess, closeDialog, clearFlags, onCreated]);
    const onSubmit = (e) => {
        e.preventDefault();
        setTouchedSubmit(true);
        if (cardId == null || cardId < 1 || !reason)
            return;
        const performedBy = buildAuthUserDisplayName(account ?? {})?.trim() || undefined;
        submitRequest({
            oldCardId: cardId,
            reason,
            sourceChannel: CARD_REPLACEMENT_DEFAULT_SOURCE_CHANNEL,
            ...(performedBy ? { performedBy } : {}),
        });
    };
    const reasonInvalid = touchedSubmit && !reason;
    return (_jsxs("div", { className: "p-mt-2", style: { maxHeight: '80vh', overflowY: 'auto' }, children: [_jsx(PCol, { children: _jsx(PRow, { justify: "between", className: "p-mb-2 p-mt-3", children: _jsx(CreateHeader, { headername: translate('entity.action.create', {
                            entity: translate('form.cardReplacementRequest'),
                        }) }) }) }), _jsx(PCol, { children: _jsxs("form", { onSubmit: onSubmit, children: [_jsxs(PRow, { children: [_jsxs(PCol, { col: 12, className: "p-field", children: [_jsx("label", { children: translate('form.card') }), _jsx(InputText, { className: "w-full", readOnly: true, value: `${card.cardReference ?? '—'} — ${card.maskedPan ?? ''}` })] }), _jsxs(PCol, { col: 12, className: "p-field", children: [_jsxs("label", { htmlFor: "replacement-reason", children: [translate('form.replacementReason'), " *"] }), _jsx(Dropdown, { id: "replacement-reason", className: classNames('w-full', { 'p-invalid': reasonInvalid }), options: CARD_REPLACEMENT_REASON_OPTIONS, optionLabel: "name", optionValue: "value", value: reason, onChange: e => setReason(e.value) }), reasonInvalid ? (_jsx("small", { className: "p-error", children: translate('form.validation.required') })) : null] })] }), _jsx(Footer, { closeDialog: closeDialog, className: "p-py-1", updating: updating })] }) })] }));
};
const mapState = ({ cardReplacementRequest, cmsAccount }) => ({
    updating: cardReplacementRequest.updating,
    updateSuccess: cardReplacementRequest.updateSuccess,
    account: cmsAccount.account,
});
const mapDispatch = (dispatch) => ({
    submitRequest: body => dispatch(createReplacementRequest(body)),
    clearFlags: () => dispatch(clearMutationFlags()),
});
export default connect(mapState, mapDispatch)(CardReplacementRequestCreateDialog);
